<template>
  <div>
    <vx-card  v-can="'view-supplier-raw-materials'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">General</label>
          <vs-input type="search"  placeholder="Search.." v-model="filters['search']" class="mb-4 md:mb-0 w-full"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Status</label>
          <v-select  :clearable="true" placeholder=""  v-model="filters['status']"
                     :options="['Pending','Approved', 'Rejected', 'Suspended - Level 1']"
                     :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
        </div>
      </div>
      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                     color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="RAW MATERIAL">
          <template slot="actions">
            <div class="flex">
              <excel-download :name="'rm-sheet'" :filters="filters"/>
              <vs-button v-can="'create-edit-supplier-raw-materials'" class="mr-4" @click="onCLickCreateRawMaterial" color="primary" type="filled">Create</vs-button>
            </div>
          </template>
          <div v-can="'view-supplier-raw-materials'" slot="no-body" class="mt-4">
            <vs-table id="raw-material-list-table" max-items="10" :data="staff"  sort  stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="20%" sort-key="company_product_code">ITS PRODUCT CODE/NAME</vs-th>
                <vs-th width="20%" sort-key="supplier_product_code">SUPPLIER PRODUCT CODE/NAME</vs-th>
                <vs-th width="20%" sort-key="name">Supplier</vs-th>
                <vs-th width="15%">Approval Status</vs-th>
                <vs-th width="15%">Production Stage</vs-th>
                <vs-th width="10%">Action</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickViewManufacturing(data[indextr])" class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].company_product_code">
                    <span class="text-primary font-bold" >
                      {{ data[indextr].company_product_code ? data[indextr].category.prefix+ '-' +data[indextr].company_product_code  : '-' }}
                    </span>
                    <br>
                    {{ data[indextr].company_product_name ?data[indextr].company_product_name : '-' }}
                  </vs-td>

                  <vs-td :data="data[indextr].supplier_product_code">
                    <HyperLink :id="data[indextr].supplier_id" :type="'supplier'">
                    {{ data[indextr].supplier_product_code }} <br>
                    {{ data[indextr].supplier_product_name }}
                    </HyperLink>
                  </vs-td>

                  <vs-td :data="data[indextr].manufacturing_site">
                    {{ data[indextr].supplier.company_name }}
                  </vs-td>

                  <vs-td :data="data[indextr].is_approved">
                    <vs-chip transparent :color="statusColorFactory(data[indextr].status ? data[indextr].status.id : '')">
                      {{data[indextr].status ? data[indextr].status.name : ''}}
                    </vs-chip>
                  </vs-td>

                  <vs-td :data="data[indextr].raw_material_stage">
                    <vs-chip transparent :color="data[indextr].raw_material_stage === 'production' ? 'primary' : 'warning'">
                      {{data[indextr].raw_material_stage || 'development'}}
                    </vs-chip>
                  </vs-td>


                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickViewManufacturing(data[indextr])"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-raw-material-without-supplier-pop-up ref="createRawMaterialWithoutSupplierPopUp" />
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import CreateRawMaterialWithoutSupplierPopUp from '@/components/popups/raw-materials/CreateRawMaterialWithoutSupplierPopUp'
  import {defaultPagination, perPageList} from "@/constants/config";

  export default {
    name: 'AllUsersList',
    data () {
      return {
        selected: [],
        updateStaffSelected: [],
        options: ['Department 01', 'Department 02', 'Department 03', 'Department 04', 'Department 05', 'Department 06'],
        popupActive: false,
        createUserPopupActive: false,
        popUpTitle: '',
        editActive: false,
        edit: null,
        editProp: {},
        checkBox1: false,
        activeConfirm: false,
        staff: [],
        selectedStaff: {},
        createStaffForm: {},
        departments: [],
        users: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        supplierId: '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      CreateRawMaterialWithoutSupplierPopUp
    },
    mixins : [Filter],
    async mounted () {
      this.setFilterId('rm_list_filters',['search','status'])
      await this.loadStaff()
    },
    methods: {
      async refreshData () {
        await this.loadStaff()
      },

      async loadStaff() {
        await this.$vs.loading({
          container: '#raw-material-list-table',
          scale: 0.45
        })
        this.supplierId = this.$route.params.id
        const {data} = await SupplierRawMaterialRepository.getRawMaterialList(this.page, this.filterQuery, this.perPage, this.sort)
        this.staff =  data.data
        this.meta = data.meta
        this.$vs.loading.close('#raw-material-list-table > .con-vs-loading')
      },

      openConfirm () {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Remove Confirm',
          text: 'Are you sure you want to permanently remove this organization?',
          accept: this.acceptAlert
        })
      },

      acceptAlert () {
        this.$vs.notify({
          color: 'danger',
          title: 'Deleted Organization',
          position:'top-right',
          text: 'The selected organization was successfully deleted'
        })
      },
      onClickViewManufacturing(data) {
        this.$router.push({path: `/pages/manage-nimble/suppliers/${data.supplier_id}/raw-material/${data.id}`})
      },
      filterQueryUpdate (){
        this.loadStaff()
      },
      async onCLickCreateRawMaterial() {
        await this.$refs.createRawMaterialWithoutSupplierPopUp.openPopup()
      },

      handleChangePage(page) {
        this.page=page;
        this.loadStaff()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.loadStaff()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      statusColorFactory(id) {
        switch (id) {
          case 1:
            return 'warning'
          case 2:
            return 'danger'
          case 3:
            return 'success'
          default:
            return 'danger'
        }
      },

    },
    watch : {
      page(){
        this.loadStaff()
      },
      perPage() {
        this.loadStaff()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
